<template>
  <div class="Empty">
    <img
      :src="require('./../../../../assets/images/product-empty.png')"
      alt
    />
    <p>{{TLang('抱歉没有找到相关的商品哦','list')}}</p>
    <div class="empty-bottom_btn">
      <span
        v-if="hideCity && !path"
        @click="searchAll"
      >{{TLang('返回上一步','list')}}</span>
      <div v-else-if="!path">
        <span
          v-if="!hideCity&&exts&&exts.includes(5)&&Number(healthgoodsFlag)===0"
          @click="$bus.$emit('changeCity')"
        >{{TLang('切换城市','list')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Empty',
  props:{
    hideCity: Boolean,
    topre: Function,
    path: String,
  },
  computed: {
    ...mapGetters('shopCart', ['exts', 'healthgoodsFlag']),
  },
  methods: {
    searchAll(){
      // window.location.href = window.location.origin + window.location.pathname + window.location.search;
      this.topre();
      setTimeout(() => {
        window.location.reload();
      }, 500);
    },
  },
};
</script>

<style lang="less" scoped>
.Empty {
  width: 100%;
  margin-top: 20px;
  text-align: center;
  img {
    width: 500px;
  }
  p {
    font-size: 15px;
    color: #999;
  }
  .empty-bottom_btn {
    margin-top: 40px;
    margin-bottom: 50px;
    span {
      display: inline-block;
      width: 136px;
      height: 40px;
      background: linear-gradient(
        315deg,
        rgba(92, 180, 236, 1) 0%,
        rgba(61, 150, 226, 1) 100%
      );
      border-radius: 4px;
      line-height: 40px;
      color: #fff;
      font-weight: bold;
      cursor: pointer;
    }
  }
}
</style>
